
export const COMETCHAT_CONSTANTS = {
    APP_ID: '204870559b7055b',
    REGION: 'US',
    API_KEY: '094f98ed5b1cc409dc5dd87ef41ec07edfd02c24',
    GUID: 'forexgroup',
    REST_API_KEY: '4b92fa033fde356fca5ca235a40d332639e290b4'
}